import React, { useEffect, useState } from 'react';

import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Link } from '~/lib/react-router-dom';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, Button, Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import { fetchBadgeDetails, removeBadge, submitPatchForm, submitPostForm } from '../../../actions/badges';

import { TAG_ICONS } from './BadgesContainer';
import BadgesForm from './BadgesForm';

interface BadgesDetailsContainerProps {
  error: { message?: string };
  success: boolean;
  isLoading: boolean;
  badge: App.Badge;
  badges: Array<App.Badge>;
  fetchBadgeDetails: (badgeId: number, badges: Array<App.Badge>) => void;
  submitPatchForm: (badge: App.Badge) => void;
  submitPostForm: (badge: App.Badge) => void;
  removeBadge: (badge: App.Badge) => void;
}

function BadgesDetailContainer({
  error,
  success,
  isLoading,
  badge: reducerBadge,
  badges,
  fetchBadgeDetails,
  submitPatchForm,
  submitPostForm,
  removeBadge,
}: BadgesDetailsContainerProps) {
  const { id_badge } = useParams<{ id_badge: string }>();
  const badgeId = parseInt(id_badge, 10);
  const [badge, setBadge] = useState<App.Badge>();

  useEffect(() => {
    fetchBadgeDetails(badgeId, badges);
  }, [badgeId, badges, fetchBadgeDetails]);

  useEffect(() => {
    setBadge(reducerBadge);
  }, [reducerBadge]);

  const checkUniqueName = (name) => {
    const uniqueName = !badges.find((b) => b.name === name);
    return uniqueName;
  };

  return (
    <Container>
      <Helmet>
        <title>Badges | {badge?.name || ''}</title>
      </Helmet>

      <Box>
        <Button component={Link} to="/marketing/badges/" startIcon={<ChevronLeftIcon />} className="T-return">
          Return to badges
        </Button>
      </Box>

      <PageHeader title={`Edit badge ${badge?.name}`} />

      <BadgesForm
        {...badge}
        tag_icons={TAG_ICONS}
        onBadgeUpdate={submitPatchForm}
        onBadgeSubmit={submitPostForm}
        onBadgeRemove={removeBadge}
        checkUniqueName={checkUniqueName}
        error={error}
        success={success}
        isLoading={isLoading}
      />
    </Container>
  );
}

const mapStateToProps = (state: App.State) => {
  const { isLoading, isUpdating, error, success, badge, items } = state.badges;

  return {
    error,
    success,
    isLoading,
    isUpdating,
    badges: items,
    badge,
  };
};

const mapDispatchToProps = {
  fetchBadgeDetails,
  submitPatchForm,
  submitPostForm,
  removeBadge,
};

export default connect(mapStateToProps, mapDispatchToProps)(BadgesDetailContainer);
